import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { Variables } from 'styles/variables/variables';
import { Colors } from 'styles/variables/colors';
import { Breakpoints } from 'styles/variables/breakpoints';
import { ReactComponent as CrossSimpleIconIcons } from 'assets/icons/cross-simple.svg';
import IconBtnIcon from 'components/common/IconBtn';
import { ReactComponent as PlayIconComponent } from 'assets/icons/play-icon-watch-video.svg';

const { darkGray, lightGrayBorder, white, gray, inputBorder } = Colors;
const { assistant } = Variables;
const { xs, sm, lg } = Breakpoints;

export const Button = styled.button`
    border-radius: 40px;
    ${TextStyle({ fontSize: '25px', fontWeight: '500', color: darkGray })};
    width: fit-content;
    white-space: nowrap;
    display: flex;
    align-items: center;
    max-height: 44px;
    gap: 0.5rem;
    padding: 24px 16px;
    background: ${inputBorder};
    border-radius: 40px;
    font-style: normal;
    line-height: 17px;
    text-transform: capitalize;
    transition: all 110ms ease-out;
    :hover {
        background: ${lightGrayBorder};
        color: ${gray};
        border: ${inputBorder};
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        path {
            fill: ${gray};
        }
    }
    :active {
        opacity: 0.9;
    }
    @media screen and (max-width: ${lg}) {
        font-size: 20px;
        gap: 0;
        padding: 9px 13px;
        word-spacing: -1px;
    }

    @media screen and (max-width: ${sm}) {
        font-size: 18px;
    }

    @media screen and (max-width: 575px) {
        font-size: 16px;
        /* margin-top: 1.2rem; */
    }

    @media screen and (max-width: ${xs}) {
        /* font-size: 18px; */
        padding: 8px 13px;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    column-gap: 1.5rem;
    margin-top: 1rem;

    @media screen and (max-width: 574px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;

        button:first-child {
            height: 36px;
        }
    }
`;

export const CrossSimpleIcon = styled(CrossSimpleIconIcons)`
    fill: ${darkGray};
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px 20px 10px;
    width: 100%;
    height: 100%;
    font-style: normal;
`;

export const IconBtn = styled(IconBtnIcon)`
    height: 24px;
    width: 24px;
    font-family: Assistant, sans-serif;
    font-size: 15px;
    color: rgb(40, 40, 40);
`;

export const Modal = styled.div`
    max-height: calc(100vh - 210px);
    overflow-y: auto;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 20px;
    position: relative;
    width: 100%;
    height: 100%;
    background: ${white};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    :focus-visible {
        outline: none;
    }
    @media screen and (max-width: ${xs}) {
        width: 90%;
    }
`;

export const ModalButtonWrapper = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const ModalWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: auto;
    display: block;
    max-width: 1000px;
    /* width: 100%; */
    min-width: 60%;
    min-height: 25%;
    :focus-visible {
        outline: none;
    }
`;

export const PlayIcon = styled(PlayIconComponent)`
    width: 40px;
    height: 40px;
    margin-right: 0.5rem;
    min-width: 24px;

    @media screen and (max-width: ${lg}) {
        width: 35px;
        height: 35px;
    }

    @media screen and (max-width: ${sm}) {
        width: 32px;
        height: 32px;
    }

    @media screen and (max-width: 575px) {
        width: 30px;
        height: 30px;
    }
    @media screen and (max-width: ${xs}) {
        width: 27px;
        height: 27px;
    }
`;

export const NoWrap = styled.span`
    @media screen and (max-width: 574px) {
        white-space: nowrap;
    }
`;

export const Text = styled.p`
    ${TextStyle({ fontSize: '22px', fontWeight: '600', color: darkGray, fontFamily: assistant })};
    text-align: center;
    font-style: normal;
    line-height: 22px;

    @media screen and (max-width: ${lg}) {
        font-size: 20px;
    }

    @media screen and (max-width: ${sm}) {
        font-size: 18px;
    }

    @media screen and (max-width: 575px) {
        font-size: 17px;
    }

    @media screen and (max-width: ${xs}) {
        font-size: 16px;
    }
`;
